import { render, staticRenderFns } from "./task-detail-header.vue?vue&type=template&id=40374501"
import script from "./task-detail-header.vue?vue&type=script&lang=js"
export * from "./task-detail-header.vue?vue&type=script&lang=js"
import style0 from "./task-detail-header.vue?vue&type=style&index=0&id=40374501&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports